import React, { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography, IconButton, Grid } from '@mui/material';
import { MdContentCopy, MdCheck } from 'react-icons/md';
import SidebarNav from '../components/Sidebar';
import TopBar from '../components/topbar';
import ImageUploader from '../components/ImageUploader';
import '../App.css';

const panelStyle = {
    background: 'rgba(255, 255, 255, 0.23)',
    border: '2px solid rgba(120, 53, 15, 0.6)',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)'
};

const UploadImage = () => {
    const [pastUploads, setPastUploads] = useState([]);
    const [copiedUrl, setCopiedUrl] = useState(null);

    const fetchPastUploads = async () => {
        try {
            const response = await fetch(`${import.meta.env.VITE_REACT_API_URL}/api/uploads/mine`, {
                credentials: 'include'
            });
            const result = await response.json();
            setPastUploads(result);
        } catch (error) {
            console.error('Error fetching past uploads:', error);
        }
    };

    useEffect(() => {
        fetchPastUploads();
    }, []);

    const handleCopy = (url) => {
        navigator.clipboard.writeText(url);
        setCopiedUrl(url);
        setTimeout(() => setCopiedUrl(null), 2000);
    };

    return (
        <div className="businessgrid">
            <div className="topNav">
                <TopBar />
            </div>
            <div className="sidebar-container">
                <SidebarNav />
            </div>
            <div className='test'>
                <h1 style={{ textAlign: 'center', color: 'white', fontSize: '60px', marginBottom: '0px' }}>Upload Image</h1>
                <p style={{ textAlign: 'center', color: 'white', fontSize: '20px', marginTop: '0px' }}>Get a permanent link for posters, notice boards, and more</p>

                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <Card sx={{ ...panelStyle, maxWidth: 600, width: '100%' }}>
                        <CardContent>
                            <Typography sx={{ color: 'rgba(254, 243, 199, 0.8)', mb: 3 }}>
                                Upload an image below, then copy the link and paste it wherever you'd normally paste an Imgur or Discord link —
                                like the notice board's "Link" field in-game. Unlike Discord links, this one won't expire.
                                Images up to 8MB (JPG, PNG, GIF, WEBP).
                            </Typography>
                            <ImageUploader onUploaded={fetchPastUploads} />
                        </CardContent>
                    </Card>
                </Box>

                {pastUploads.length > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, px: 2 }}>
                        <Card sx={{ ...panelStyle, maxWidth: 600, width: '100%' }}>
                            <CardContent>
                                <Typography variant="h6" sx={{ color: '#ffffff', mb: 2 }}>My Uploads</Typography>
                                <Grid container spacing={1}>
                                    {pastUploads.map((upload) => (
                                        <Grid item xs={4} sm={3} key={upload.url}>
                                            <Box sx={{ position: 'relative' }}>
                                                <Box component="img" src={upload.url} sx={{ width: '100%', height: 80, objectFit: 'cover', borderRadius: '6px', border: '1px solid rgba(245, 158, 11, 0.4)' }} />
                                                <IconButton
                                                    size="small"
                                                    onClick={() => handleCopy(upload.url)}
                                                    sx={{ position: 'absolute', top: 2, right: 2, bgcolor: 'rgba(0,0,0,0.6)', color: '#f59e0b', '&:hover': { bgcolor: 'rgba(0,0,0,0.8)' } }}
                                                >
                                                    {copiedUrl === upload.url ? <MdCheck size={16} /> : <MdContentCopy size={16} />}
                                                </IconButton>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                                <Typography variant="caption" sx={{ color: 'rgba(254, 243, 199, 0.6)', mt: 1, display: 'block' }}>
                                    Reuse an old link instead of uploading the same image again — click the copy icon.
                                </Typography>
                            </CardContent>
                        </Card>
                    </Box>
                )}
            </div>
        </div>
    );
};

export default UploadImage;
